import { render, staticRenderFns } from "./pencil-34.vue?vue&type=template&id=7dc9c776&scoped=true"
import script from "./pencil-34.vue?vue&type=script&lang=js"
export * from "./pencil-34.vue?vue&type=script&lang=js"
import style0 from "./pencil-34.vue?vue&type=style&index=0&id=7dc9c776&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc9c776",
  null
  
)

export default component.exports